// extracted by mini-css-extract-plugin
module.exports = {"image":"DocumentViewer_image__1EKXy","pdf":"DocumentViewer_pdf__14lQG"};